<div class="card pt-3 h-100">
  <div>
    <i class="fa fas fa-check-circle succes-icon"></i>
  </div>
  <strong class="primary-text">Thank you</strong>
  <div class="message-text">{{ successMessage }}</div>
  <!-- Download PDF: a copy of exactly what was just submitted. The answers are held in memory
       only, so after a refresh there is nothing to print and the button is not shown. -->
  <div *ngIf="canDownload" class="mt-3 mb-3 text-center">
    <button type="button" class="btn btn-outline-success" (click)="downloadPdf()" [disabled]="downloading">
      <i class="fa fas fa-file-pdf me-1"></i>{{ downloading ? 'Preparing PDF…' : 'Download PDF' }}
    </button>
    <div class="text-muted small mt-1">A copy of the form you submitted</div>
  </div>
</div>
